<template>
  <vg-card>
    <vg-form>
        <dp-application-field
            ref="fields"
            v-for="field in fields"
            :key="field.applicationSituationId"
            :type="field.attributeType"
            :label="field.attributeName"
            :disabled="field.disable"
            :field-rule="field.fieldRule"
            v-model="field.value"
        />
    </vg-form>
  </vg-card>
</template>

<script>
import DpApplicationField
  from "@/views/DigitalPassApplications/DigitalPassApplicationForm/DpApplicationField/index.vue";
import VgCard from "@/components/Commons/VgCard.vue";
import VgForm from "@/components/Commons/VgForm.vue";

export default {
  name: "DpApplicationCommonForm",
  components: {VgForm, VgCard, DpApplicationField},
  props: {
    value: null
  },
  computed: {
    fields() {
      return this.value?.fields || []
    }
  },
  methods: {
    validate() {
      return this.$refs.fields.flatMap(form => form?.validate())
    }
  }
}
</script>

<style scoped>

</style>